import BottomNavigator from "./BottomNavigator";

export default BottomNavigator;
